import React, { useState } from 'react';
import {
  Box,
  Button,
  Tab,
  Tabs,
  TextField,
  Typography,
  Card,
  CardContent,
} from '@mui/material';
import PageShell from './components/PageShell';
import { subscriptionAdminApi } from '../subscriptionAdmin/api';
function ReportPanel({ title, fetcher, from, to }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      const params = {};
      if (from) params.from = new Date(from).toISOString();
      if (to) params.to = new Date(to).toISOString();
      const result = await fetcher(params);
      setData(result);
    } catch (err) {
      setError(err.message || 'Failed to load report');
      setData(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card sx={{ mt: 2 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>{title}</Typography>
        <Button size="small" variant="outlined" onClick={load} disabled={loading} sx={{ mb: 2 }}>
          {loading ? 'Loading…' : 'Run report'}
        </Button>
        {error && <Typography color="error">{error}</Typography>}
        {data && (
          <Box
            component="pre"
            sx={{
              fontSize: 12,
              overflow: 'auto',
              bgcolor: '#f1f5f9',
              p: 2,
              borderRadius: 1,
              maxHeight: 360,
            }}
          >
            {JSON.stringify(data, null, 2)}
          </Box>
        )}
      </CardContent>
    </Card>
  );
}

export default function ReportsPage() {
  const [tab, setTab] = useState(0);
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');

  const reports = [
    { label: 'GST summary', fn: (p) => subscriptionAdminApi.gstSummary(p) },
    { label: 'Revenue', fn: (p) => subscriptionAdminApi.reportRevenue(p) },
    { label: 'MRR', fn: (p) => subscriptionAdminApi.reportMrr(p) },
    { label: 'Outstanding', fn: (p) => subscriptionAdminApi.reportOutstanding(p) },
    { label: 'Contract pipeline', fn: (p) => subscriptionAdminApi.reportPipeline(p) },
    { label: 'Usage vs quota', fn: (p) => subscriptionAdminApi.reportUsageVsQuota(p) },
  ];

  return (
    <PageShell
      title="Step 8 — Reports"
      subtitle="GET /reports/revenue · gst-summary · mrr · outstanding · contract-pipeline · usage-vs-quota"
    >
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 2 }}>
        <TextField label="From" type="date" size="small" value={from} onChange={(e) => setFrom(e.target.value)} InputLabelProps={{ shrink: true }} />
        <TextField label="To" type="date" size="small" value={to} onChange={(e) => setTo(e.target.value)} InputLabelProps={{ shrink: true }} />
      </Box>

      <Tabs value={tab} onChange={(_, v) => setTab(v)} variant="scrollable" scrollButtons="auto">
        {reports.map((r) => (
          <Tab key={r.label} label={r.label} />
        ))}
      </Tabs>

      <ReportPanel title={reports[tab].label} fetcher={reports[tab].fn} from={from} to={to} />
    </PageShell>
  );
}
